<template>

</template>

<script setup>
  import notify from 'devextreme/ui/notify'
  import { watch } from "vue";
  import { storeToRefs } from "pinia";
  import { useToastStore } from "@/stores/toastStore.js";

  const toastStore = useToastStore()
  const { toastQueue } = storeToRefs(toastStore)

  const toastStack = {
    position: 'bottom center',
    direction: 'up-push' // New toasts push existing ones up
  }

  watch(() => toastQueue.value.length, (queueLength) => {
    // Process all messages in the queue
    if (queueLength > 0) {
      const queueCopy = [...toastQueue.value]

      queueCopy.forEach((toast) => {
        const notifyOptions = {
          message: toast.message,
          type: toast.type || 'info', // Types: info, warning, error, success
          icon: toast.icon, // FIXME: icons not appearing
          closeOnClick: true
        }

        // Trigger toast notification with stack configuration
        notify(notifyOptions, toastStack)

        // Remove from queue after triggering
        toastStore.removeToastFromQueue(toast.id)
      })
    }
  })
</script>

<style lang="scss">
  .dx-toast-icon {
    display: inline-flex !important;
  }
</style>
